import ServiceSection from './service-section'
import webDesignImage from '@/public/pages/home/seo2.png'

export default function WebDesign() {
  return <ServiceSection
    category="Design & Development"
    description="We design and build ecommerce stores around your products, your customers, and the way your team works."
    image={webDesignImage}
    imageAlt="Ecommerce Website Design"
    href="/web-design"
    buttonText="Ecommerce Website Design Services"
  />
}
